import { render, staticRenderFns } from "./NewsChangeActivationType.vue?vue&type=template&id=4dc0542e&"
import script from "./NewsChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./NewsChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports